// ABOUTME: What the card may offer, read off the card alone: whether the video room is open for joining right now, and
// ABOUTME: whether the booked time has begun, after which nothing but the join is offered.
import {
  InterviewAppointmentStatus,
  InterviewCardData,
  InterviewKind,
  InterviewStatus
} from './types';

/**
 * Whether the join button shows: a VIDEO interview that is booked and whose room has opened. The card says when the
 * room opens but not when it closes (roomClosesMinutesAfter the end), so a pass asked for after that is refused with
 * error.interview.room-closed, which the card shows.
 */
export const canJoinNow = (card: InterviewCardData, now: number): boolean =>
  card.kind === InterviewKind.VIDEO &&
  card.status === InterviewStatus.SCHEDULED &&
  !!card.joinOpensAt &&
  now >= new Date(card.joinOpensAt).getTime();

/**
 * Whether the booked time has begun. From then on the card offers no cancel, no move and no "Still on?" answer, only
 * the join while the room is open: a cancel in the middle of the call is not what a talent who taps it there means.
 */
export const hasStarted = (card: InterviewCardData, now: number): boolean =>
  card.status === InterviewStatus.SCHEDULED &&
  card.appointment?.status === InterviewAppointmentStatus.CONFIRMED &&
  now >= new Date(card.appointment.startsAt).getTime();
